import { AcquirerType } from '../demandTypes';
import { useField } from 'react-final-form';

export const useAcquirerTypeFormValue = (): AcquirerType | undefined => {
  return useField('acquirer.type', { subscription: { value: true } }).input.value;
};
